import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/equipmentLive/nothing.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-16c8b3c6"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "equipment-live-list"
};
var _hoisted_2 = {
  key: 1,
  class: "nothing"
};
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0
  }, null, -1);
});
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "暂无数据", -1);
});
var _hoisted_5 = [_hoisted_3, _hoisted_4];
var _hoisted_6 = {
  class: "title-box flex align-center"
};
var _hoisted_7 = {
  class: "title text-center"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_device_list_item = _resolveComponent("device-list-item");
  var _component_device_detail_temp = _resolveComponent("device-detail-temp");
  var _component_Loading = _resolveComponent("Loading");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [!_ctx.showLoading ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_ctx.type != 'temp' ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_ctx.list1.length ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList(_ctx.list1, function (item, index) {
    return _openBlock(), _createBlock(_component_device_list_item, {
      key: item.deviceId,
      item: item,
      index: index,
      onUpdate: _ctx.updateDevice
    }, null, 8, ["item", "index", "onUpdate"]);
  }), 128)) : (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))], 64)) : (_openBlock(true), _createElementBlock(_Fragment, {
    key: 1
  }, _renderList(_ctx.listTemp, function (item) {
    return _openBlock(), _createElementBlock("div", {
      key: item.deviceId,
      style: {
        "margin-bottom": "30px"
      }
    }, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(item.device), 1)]), _createVNode(_component_device_detail_temp, {
      id: item.deviceId
    }, null, 8, ["id"])]);
  }), 128))], 64)) : (_openBlock(), _createBlock(_component_Loading, {
    key: 1,
    size: "44",
    vertical: "",
    class: "show-loading",
    color: "#4372f6"
  }, {
    default: _withCtx(function () {
      return [_createTextVNode("加载中...")];
    }),
    _: 1
  }))]);
}